import { ChangeDetectorRef, Component } from '@angular/core';

@Component({
  selector: 'xux-icon-defs',
  templateUrl: 'xux-icon-defs.component.html',
})
export class XuxIconDefsComponent {

  public constructor(changeDetectorRef: ChangeDetectorRef) {
    changeDetectorRef.detach();
  }

}
